export const USERS_RECORD_KEY = 'users';
export interface User {
    email: string;
    id: string;
    roles: string[];
    agency_id: string;
    name: string;
}
